var _rect, _path, _path2, _circle, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.2962,
    y: 3.35659,
    width: 14.7788,
    height: 14.2994,
    rx: 1,
    transform: "rotate(44.8105 12.2962 3.35659)",
    stroke: "#ECEDEA",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7394 23.2246L22.2883 13.1573H3.19059L12.7394 23.2246Z",
    fill: "#ECEDEA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6196 13.8452L10.3426 1.17258",
    stroke: "#ECEDEA",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.1369,
    cy: 22.026,
    r: 1.67788,
    fill: "#ECEDEA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1369 18.9099L23.5899 21.0672H20.6838L22.1369 18.9099Z",
    fill: "#ECEDEA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContain);
export default __webpack_public_path__ + "static/media/contain.956129e348b81d37704cc7ced9187d52.svg";
export { ForwardRef as ReactComponent };